import { createAction, props } from '@ngrx/store';

import { PermissionList } from '../../core/domain/permission-list.entity';

export enum PermissionActions {
	FetchUserPermissionsForProjectSuccess = '[BE][Project][Permission] Fetch user permissions for project success',
	FetchUserPermissionsForProjectFail = '[BE][Project][Permission] Fetch user permissions for project fail',
}

export const fetchUserPermissionsForProjectSuccess = createAction(
	PermissionActions.FetchUserPermissionsForProjectSuccess,
	props<{ permissions: PermissionList }>()
);

export const fetchUserPermissionsForProjectFail = createAction(
	PermissionActions.FetchUserPermissionsForProjectFail,
	props<{ error: unknown }>()
);
